// extracted by mini-css-extract-plugin
export default {"buttonStyle":"Hero_buttonStyle__0Yyk2","hero":"Hero_hero__pPV-s","frame":"Hero_frame__kRceI","details":"Hero_details__0U1bi","home":"Hero_home__3g82C"};